import type { PropsWithChildren, ReactNode } from 'react';
import type { Theme, SxProps, DialogProps, ModalProps as MuiModalProps } from '@mui/material';
import { Dialog } from '@mui/material';
import { BottomSheet } from '../bottom-sheet';
import { Hidden } from '../hidden';
import { DialogTitle } from '../dialog-title';
interface IModalProps extends Omit<MuiModalProps, 'children'> {
  title?: string;
  open: boolean;
  onClose: () => void;
  headerIcon?: ReactNode;
  sx?: SxProps<Theme>;
  titleElement?: ReactNode;
  id?: string;
  dialogProps?: Partial<DialogProps>;
}
export type ModalProps = PropsWithChildren<IModalProps>;
export function Modal({
  title,
  open,
  onClose,
  children,
  headerIcon,
  sx,
  titleElement,
  id,
  dialogProps,
  ...rest
}: ModalProps) {
  let dialogTitleContent = null;
  if (titleElement !== undefined) {
    dialogTitleContent = titleElement;
  } else if (title) {
    dialogTitleContent = <DialogTitle headerIcon={headerIcon} onClose={onClose}>
        {title}
      </DialogTitle>;
  }
  return <>
      <Hidden for='desktop' data-sentry-element="Hidden" data-sentry-source-file="Modal.tsx">
        <BottomSheet headerIcon={headerIcon} id={id} open={open} sx={sx} title={title} titleElement={titleElement} onClose={onClose} {...rest} data-sentry-element="BottomSheet" data-sentry-source-file="Modal.tsx">
          {children}
        </BottomSheet>
      </Hidden>
      <Hidden for='mobile' data-sentry-element="Hidden" data-sentry-source-file="Modal.tsx">
        <Dialog id={id} open={open} sx={sx} onClose={onClose} {...rest} {...dialogProps} data-sentry-element="Dialog" data-sentry-source-file="Modal.tsx">
          {dialogTitleContent}
          {children}
        </Dialog>
      </Hidden>
    </>;
}